<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'
import { get } from 'lodash'

export default {
  extends: BaseWidgetForm,
  data() {
    return {
      arrayFields: ['items']
    }
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Header({
              text: 'Kafle'
            }),
            new fields.Formset({
              modelPath: [this, 'form', 'items'],
              maxItems: 3,
              items: this.form.items.map((item, i) => ({
                headerLabel: get(item, ['title_pl']),
                fields: [
                  new fields.Input({
                    label: 'Tytuł',
                    required: true,
                    type: 'textarea',
                    modelPath: [this, 'form', 'items', i, 'title'],
                    multilingual: true
                  }),
                  new fields.Image({
                    label: 'Logo',
                    required: true,
                    modelPath: [this, 'form', 'items', i, 'logo']
                  }),
                  new fields.Link({
                    label: 'Odnośnik',
                    required: true,
                    modelPath: [this, 'form', 'items', i, 'link'],
                    hideLinkLabel: true
                  }),
                  new fields.Color({
                    label: 'Kolor',
                    modelPath: [this, 'form', 'items', i, 'color'],
                    required: true
                  })
                ]
              }))
            })
          ]
        }
      ]
    }
  }
}
</script>
